<div class="store-list">
  <div #searchElement class="search">
    <app-title [titles]="[title]" class="title" />

    <div class="input-wrapper">
      <div class="input">
        <input
          #inputLocationElement
          (blur)="onInputBlur()"
          (focus)="onInputFocus()"
          (input)="onInputChange($event)"
          (keydown)="onInputKeydown($event)"
          class="input-text input-border"
          placeholder="Veuillez indiquer une ville"
          type="text" />
      </div>

      @if (showDropdown() && locationSuggestions().length > 0) {
        <div class="dropdown">
          @for (location of locationSuggestions(); track location.id) {
            <div (click)="selectLocation(location)" class="dropdown-item">
              {{ location.name }}
            </div>
          }
        </div>
      }
    </div>

    <app-button
      (click)="onGeolocalise()"
      [icon]="{ name: 'PIN', position: 'LEFT', size: '2rem' }"
      [style]="{ width: '100%' }"
      label="Utiliser votre position géographique" />
    @if (error()) {
      <div class="error">{{ error() }}</div>
    }
  </div>
  @if (isStoresLoaded()) {
    <ul #storesList [style.--height]="searchElement.offsetHeight + 'px'" class="list">
      @if (storesVisible$ | async; as storesVisible) {
        @for (store of stores$ | async; track store) {
          @if (storesVisible | isStoreVisible: store.uuid) {
            <li class="item">
              <app-store-detail [store]="store" [urlAppointment]="urlAppointment$ | async" />
            </li>
          }
        }
      }
    </ul>
  } @else {
    <div class="loading">
      <div class="spinner"></div>
    </div>
  }
  <ng-template #loading>
    <div class="loading">
      <div class="spinner"></div>
    </div>
  </ng-template>
</div>
